function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9 2.5H4C3.17157 2.5 2.5 3.17157 2.5 4V9C2.5 9.82843 3.17157 10.5 4 10.5H9C9.82843 10.5 10.5 9.82843 10.5 9V4C10.5 3.17157 9.82843 2.5 9 2.5Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5 6L7 8L10 5",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20 2.5H15C14.1716 2.5 13.5 3.17157 13.5 4V9C13.5 9.82843 14.1716 10.5 15 10.5H20C20.8284 10.5 21.5 9.82843 21.5 9V4C21.5 3.17157 20.8284 2.5 20 2.5Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16 6L18 8L21 5",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9 13.5H4C3.17157 13.5 2.5 14.1716 2.5 15V20C2.5 20.8284 3.17157 21.5 4 21.5H9C9.82843 21.5 10.5 20.8284 10.5 20V15C10.5 14.1716 9.82843 13.5 9 13.5Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M5 17L7 19L10 16",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M20 13.5H15C14.1716 13.5 13.5 14.1716 13.5 15V20C13.5 20.8284 14.1716 21.5 15 21.5H20C20.8284 21.5 21.5 20.8284 21.5 20V15C21.5 14.1716 20.8284 13.5 20 13.5Z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M16 17L18 19L21 16",
  stroke: "white",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSelectAll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAll);
export default __webpack_public_path__ + "static/media/select-all.7cab1e2d.svg";
export { ForwardRef as ReactComponent };